export enum ExternalLinks {
  privacyPolicyLink = 'https://www.acuvue.ru/terms-of-use/',
  myAcuvueProgramPolicyLink = 'https://www.acuvue.ru/pravila-programmy-myacuvue',
  legalNoticeLink = 'https://www.acuvue.ru/terms-of-use/',
  consentLink = 'https://www.acuvue.ru/consent-to-receive-promo-info/',
  mobileMarket = 'https://myacuvue.onelink.me/o8U8/acuvueru',
  ruStore = 'https://myacuvue.onelink.me/o8U8/lrhic58v',
  locator = 'https://myacuvue.onelink.me/o8U8/ECPLocator',
  // Wiki links
  visionAndGadgets = 'https://www.acuvue.ru/eye-health/digital-eye-strain/', // doesn't work
  visionAndWork = 'https://www.acuvue.ru/eye-health/tips-for-work/', // doesn't work
  visionAndUV = 'https://www.acuvue.ru/considering-contacts/uv-blocking-benefits/', // doesn't work
  popularProblems = 'https://www.acuvue.ru/eye-health/common-vision-issues/', // works
  astigmatismWiki = 'https://www.acuvue.ru/eye-health/astigmatism/', // doesn't work
  presbyopiaWiki = 'https://www.acuvue.ru/eye-health/presbyopia/', // doesn't work
  weeklyLenses = 'https://www.acuvue.ru/products?rf[88]=88', // works
  dailyLenses = 'https://www.acuvue.ru/products?rf[87]=87', // works
  typesOfLenses = 'https://www.acuvue.ru/products/types-of-contacts', // doesn't work
  cleanAndCare = 'https://www.acuvue.ru/new-wearer/contact-lens-cleaning-and-care/', // doesn't work
  takeOutLenses = 'https://www.acuvue.com/ru-ru/new-wearer/new-wearer-guide/', // not in the file
  usefulTips = 'https://www.acuvue.com/ru-ru/new-wearer/new-wearer-guide/', // not in the file,
  putInLenses = 'https://www.acuvue.com/ru-ru/new-wearer/new-wearer-guide/', // not in the file
  commonMyths = 'https://www.acuvue.com/ru-ru/considering-contacts/contact-lens-myths/',
  lensesBenefits = 'https://www.acuvue.ru/considering-contacts/new-contact-lenses', // works
  contactLensesFacts = 'https://www.acuvue.ru/considering-contacts/why-acuvue/', // doesn't work
  fittingPreparation = 'https://www.acuvue.com/ru-ru/get-contacts/prepare-for-appointment/', // not in the file
  lensesFitting = 'https://www.acuvue.com/ru-ru/get-contacts/how-to-get-contacts/', // not in the file
  // Social media
  mailLink = 'mailto:acuvue@jnj.ru',
  phoneNumber = '88006007997',
  mobileLinkRevitalLens = 'https://myacuvue.onelink.me/o8U8/dsvm7p8c',
  myopia = 'https://www.acuvue.ru/eye-health/myopia?utm_source=MA&utm_medium=email&utm_campaign=crm-miopiya',
  presbyopia = 'https://www.acuvue.ru/eye-health/presbyopia?utm_source=MA&utm_medium=email&utm_campaign=crm-presbiopia',
  astigmatism = 'https://www.acuvue.ru/eye-health/astigmatism?utm_source=MA&utm_medium=email&utm_campaign=crm-astigmatism',
  phoneConsentLink = 'https://www.acuvue.ru/consent-to-phone-calls/',
  yandexVideoUrl = 'https://runtime.video.cloud.yandex.net',
}
